import {formatMoney} from '@shopify/theme-currency/currency';
import Component from "./../../component";

export const CartDrawerSummaryConfig = {
    signature: 'cartDrawerSummary',
    baseHtmlClass: 'go-cart__drawer__summary',
    selector: '.go-cart__drawer__summary',

    initedHtmlClassModifier: 'inited',

    freeShippingThreshold: 13000,
};

export class CartDrawerSummary extends Component {

    constructor(id_or_element, goCart) {
        super({
            element: id_or_element,
            config: CartDrawerSummaryConfig
        });

        this.goCart = goCart;

        this.cartItemCount = null;
        this.cartSubtotal = null;
        this.moneyFormat = null;

        this.inited = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, CartDrawerSummaryConfig.initedHtmlClassModifier);
        let content = ``;
        if (this.cartHasItems()) {
            const giftWrapContent = this.isGiftWrap() ? `<li>Gift wrapped with message</li>` : '';
            const promocodeContent = this.hasPromocode() ? `<li>Discount code set</li>` : '';
            const itemsContent = `<li>${this.cartItemCount} ${this.cartItemsLabel()} for ${this.renderCartSubtotal()}</li>`;
            content = `${giftWrapContent} ${promocodeContent} ${itemsContent} ${this.renderShippingContent()}`;
        }
        this.element.innerHTML = content;
    }

    renderShippingContent() {
        if (this.cartSubtotal == null) return '';
        if (!this.hasFreeShipping()) return '';
        return `<li>Free shipping<sup>*</sup></li>`;
    }

    renderCartSubtotal() {
        if (this.moneyFormat == null) return;
        if (this.cartSubtotal == null) return;
        return formatMoney(this.cartSubtotal, this.moneyFormat)
    }

    cartHasItems() {
        if (Number.isNaN(this.cartItemCount)) return false;
        return this.cartItemCount > 0;
    }

    cartItemsLabel() {
        if (this.cartHasItems() && this.cartItemCount > 1) return 'items';
        if (this.cartHasItems() && this.cartItemCount === 1) return 'item';
        return 'items';
    }

    isGiftWrap() {
        if (!this.goCart) return false;
        return this.goCart.isGiftWrap();
    }

    hasPromocode() {
        if (!this.goCart) return false;
        return this.goCart.hasPromocode();
    }

    hasFreeShipping() {
        if (this.cartSubtotal == null) return false;
        return (this.cartSubtotal >= CartDrawerSummaryConfig.freeShippingThreshold);
    }

}
